import { render, staticRenderFns } from "./CreateCustomLabelTeachModal.vue?vue&type=template&id=4c063d13&scoped=true&"
import script from "./CreateCustomLabelTeachModal.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomLabelTeachModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCustomLabelTeachModal.vue?vue&type=style&index=0&id=4c063d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c063d13",
  null
  
)

export default component.exports